import { BreadcrumbItemType } from "antd/es/breadcrumb/Breadcrumb";
import { HomeOutlined } from "@ant-design/icons";
import React from "react";

export const coverPath = "/cover/";
export const defaultBcPath:BreadcrumbItemType[] = [
    {
        href: '/',
        title: (<span><HomeOutlined /> Start</span>),
    }]